document.addEventListener("DOMContentLoaded", function () {
  const triggerBtn = document.getElementById("cart-drawer-button-section");

  if (triggerBtn) {
    triggerBtn.addEventListener("click", function () {
      // Try to find the "real" open button inside the cart drawer component
      const cartDrawer = document.querySelector("cart-drawer-component");

      if (!cartDrawer) return;

      const openButton = cartDrawer.querySelector('button[on\\:click="/open"]');

      if (openButton) {
        openButton.click();
      } else {
        console.warn("Cart drawer open button not found");
      }
    });
  }

  function updateCallOuts() {
    const lastVariantAdded = window.localStorage.getItem("lastVariantAdded");
    const cartItemCallOut = document.querySelector(
      `[data-call-out="${lastVariantAdded}"]`
    );
    if (cartItemCallOut) cartItemCallOut.classList.remove("hidden");
  }
  document.addEventListener("cart:update", () => {
    updateCallOuts();
  });

  updateCallOuts();

  // Afterpay/Square messaging update on variant change
  document.addEventListener("variant:update", function (event) {
    const variant = event.detail?.resource;
    const newHtml = event.detail?.data?.html;
    
    if (!variant || variant.price === undefined) return;

    // Method 1: Replace Afterpay elements from server response HTML
    // This ensures the Afterpay app block renders with the correct variant price
    if (newHtml) {
      const newAfterPayElements = newHtml.querySelectorAll(
        "afterpay-placement, square-placement, [data-afterpay-placement], [data-square-placement]"
      );
      
      newAfterPayElements.forEach((newElement) => {
        // Find matching element in current DOM and replace it
        const selector = newElement.tagName.toLowerCase();
        const currentElements = document.querySelectorAll(selector);
        
        currentElements.forEach((currentElement) => {
          // Replace the current element with the new one from the response
          if (currentElement.parentNode) {
            currentElement.parentNode.replaceChild(
              newElement.cloneNode(true),
              currentElement
            );
          }
        });
      });
    }

    // Method 2: Also update data-amount directly as a fallback
    const placements = document.querySelectorAll(
      "afterpay-placement, square-placement, [data-afterpay-placement], [data-square-placement]"
    );
    
    placements.forEach((placement) => {
      // Shopify variant.price is in cents (e.g., 3895 for $38.95)
      // Afterpay expects amount in dollars with cents (e.g., "38.95")
      // Convert from cents to dollars
      const priceInDollars = (variant.price / 100).toFixed(2);
      
      if (placement.getAttribute("data-amount") !== priceInDollars) {
        placement.setAttribute("data-amount", priceInDollars);
      }
    });

    // Method 3: Trigger refresh APIs if available
    requestAnimationFrame(() => {
      if (window.Square?.Payments?.Afterpay?.refresh) {
        window.Square.Payments.Afterpay.refresh();
      } else if (window.Afterpay?.refresh) {
        window.Afterpay.refresh();
      }
      
      // Dispatch custom event for any listeners
      document.dispatchEvent(new CustomEvent("afterpay:refresh", { 
        detail: { amount: variant.price / 100 } 
      }));
    });
  });
});
